if (!customElements.get('fiorit-rose-picker')) {
  customElements.define('fiorit-rose-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.countInput = this.querySelector('[data-rose-count]');
      this.lengthInput = this.querySelector('[data-rose-length]');
      this.addButton = this.querySelector('[data-rose-add]');
      this.minusButton = this.querySelector('[data-rose-minus]');
      this.plusButton = this.querySelector('[data-rose-plus]');
      this.message = this.querySelector('[data-rose-message]');
      this.price = this.querySelector('[data-rose-price]');
      this.messages = JSON.parse(this.querySelector('[data-rose-messages]').textContent);
      this.state = JSON.parse(this.querySelector('[data-rose-initial]').textContent);
      this.countIds = new Map(Array.from(this.querySelectorAll('[data-count-value]'), el => [el.dataset.countValue, el.dataset.optionValueId]));
      this.stateKey = this.key();
      this.requestId = 0;
      this.busy = false;
      this.render();
      this.countInput.addEventListener('input', () => this.schedule());
      this.countInput.addEventListener('change', () => this.resolve());
      this.lengthInput.addEventListener('change', () => this.resolve());
      this.minusButton.addEventListener('click', () => this.step(-1));
      this.plusButton.addEventListener('click', () => this.step(1));
      this.form.addEventListener('submit', event => this.submit(event));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
    key() { return `${this.lengthInput.value}:${this.countInput.value}`; }
    valid() {
      return /^\d+$/.test(this.countInput.value) && Number(this.countInput.value) >= 6 && Number(this.countInput.value) <= 100;
    }
    render() {
      const count = Number(this.countInput.value);
      const matching = this.state && this.stateKey === this.key() && this.state.count === count && String(this.state.productId) === this.dataset.productId;
      this.addButton.disabled = this.busy || !this.valid() || !matching || !this.state.available;
      this.minusButton.disabled = this.busy || count <= 6;
      this.plusButton.disabled = this.busy || count >= 100;
      this.countInput.disabled = this.busy;
      this.lengthInput.disabled = this.busy;
      this.countInput.setAttribute('aria-invalid', String(!this.valid()));
      if (matching && this.valid()) {
        this.price.textContent = this.state.money;
        this.form.elements.id.value = this.state.id;
      } else this.price.textContent = '—';
    }
    step(delta) {
      if (this.busy) return;
      const value = this.valid() ? Number(this.countInput.value) + delta : 6;
      this.countInput.value = String(Math.min(100, Math.max(6, value)));
      this.resolve();
    }
    schedule() {
      clearTimeout(this.timer);
      this.requestId++;
      this.controller?.abort();
      this.stateKey = '';
      this.message.textContent = this.valid() ? this.messages.loading : this.messages.invalid;
      this.render();
      if (this.valid()) this.timer = setTimeout(() => this.resolve(), 220);
    }
    async resolve() {
      clearTimeout(this.timer);
      this.controller?.abort();
      const requestId = ++this.requestId;
      const key = this.key();
      this.stateKey = '';
      this.render();
      if (!this.valid()) {
        this.message.textContent = this.messages.invalid;
        return false;
      }
      const countId = this.countIds.get(this.countInput.value);
      if (!countId) {
        this.message.textContent = this.messages.unavailable;
        return false;
      }
      this.message.textContent = this.messages.loading;
      this.controller = new AbortController();
      try {
        const url = new URL(this.dataset.productUrl, location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.searchParams.set('option_values', `${this.lengthInput.value},${countId}`);
        url.searchParams.set('section_id', 'fiorit-rose-state');
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('variant_request');
        const html = await response.text();
        const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-fiorit-rose-state]');
        if (!node) throw new Error('variant_response');
        const state = JSON.parse(node.textContent);
        if (requestId !== this.requestId || key !== this.key()) return false;
        if (!state || String(state.productId) !== this.dataset.productId || state.count !== Number(this.countInput.value) || !state.id) throw new Error('variant_mismatch');
        this.state = state;
        this.stateKey = key;
        this.message.textContent = state.available ? '' : this.messages.unavailable;
        this.render();
        if (state.available) {
          const shareUrl = new URL(location.href);
          shareUrl.searchParams.delete('option_values');
          shareUrl.searchParams.set('variant', state.id);
          history.replaceState({}, '', shareUrl);
        }
        return state.available;
      } catch (error) {
        if (error.name === 'AbortError' || requestId !== this.requestId) return false;
        this.message.textContent = this.messages.error;
        this.render();
        return false;
      }
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      if (!this.valid()) {
        this.message.textContent = this.messages.invalid;
        this.countInput.focus();
        return;
      }
      if (this.stateKey !== this.key() && !await this.resolve()) return;
      if (!this.state?.available || this.state.count !== Number(this.countInput.value)) return;
      this.busy = true;
      this.addButton.textContent = this.messages.adding;
      this.render();
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: this.state.id, quantity: 1 }] })
        });
        if (!response.ok) throw new Error('cart_request');
        location.assign(this.dataset.cartUrl);
      } catch (_) {
        this.busy = false;
        this.message.textContent = this.messages.error;
        this.addButton.textContent = this.messages.add;
        this.render();
      }
    }
  });
}
